export default __webpack_public_path__ + "static/13-aefaf9b9c9b56fba1da4e87241fac4e2.webp";